export interface OnboardingStep {
  id: string;
  title: string;
  content: string[];
  emoji: string;
  actionButtonText?: string;
  skipEnabled?: boolean;
}

export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    id: 'welcome',
    title: 'Welcome to WealthPlay!',
    content: [
      'Turn your financial journey into an engaging adventure!',
      'WealthPlay combines personal finance management with gamification to make building wealth fun and rewarding.',
      'Complete quests, play games, earn XP, and level up your financial skills!'
    ],
    emoji: '🎮',
    actionButtonText: 'Get Started'
  },
  {
    id: 'features',
    title: 'Key Features',
    content: [
      '🏁 Quests: Complete financial challenges to earn XP and rewards',
      '🎯 Games: Fun mini-games that teach financial concepts while earning lives',
      '💰 XP System: Level up by completing activities and building good habits',
      '🏦 Bank Integration: Connect your accounts for automatic expense tracking (optional)',
      '📊 Budget Tools: Use the 50/30/20 method and other budgeting strategies'
    ],
    emoji: '✨',
    actionButtonText: 'Learn More'
  },
  {
    id: 'goal-setting',
    title: 'Set Your Financial Goal',
    content: [
      'What brings you to WealthPlay today?',
      'Setting a clear goal helps us personalize your experience and recommend the best quests and activities for your journey.',
      'Don\'t worry - you can change this anytime in your profile!'
    ],
    emoji: '🎯',
    actionButtonText: 'Choose Goal'
  },
  {
    id: 'navigation',
    title: 'Quick Navigation Tour',
    content: [
      '🏁 Quests: Your main hub for financial challenges and activities',
      '🏠 Home: Your dashboard with spending overview and transaction history',
      '🎮 Games: Fun ways to learn and earn lives for more quest attempts',
      '👤 Profile: Track your progress, achievements, and settings'
    ],
    emoji: '🧭',
    actionButtonText: 'Start Journey',
    skipEnabled: true
  }
];

export const ONBOARDING_GOALS = [
  'Save for a big purchase',
  'Track and reduce spending', 
  'Build an emergency fund',
  'Learn budgeting basics',
  'Improve financial habits'
];